<template lang="pug">
div
  h2 {{ $t("miscellaneous") }}
  .link-wrapper.mt-3
    a(:href="configApi.getGDPRURL + '?download=true'", @click="saveGDPRtxt") {{ $t("downloadDataRelatedToMe") }}
    router-link.navbar__item(v-if="isCovidAvailable", to="/vaccination/") 
      a(@click="close") {{ $t("covid") }}
    router-link.navbar__item(
      v-if="isTestcenterAvailable",
      to="/test-center/",
      @click="close"
    ) 
      a(@click="close") {{ $t("tests") }}
    router-link.navbar__item(
      v-if="isCompletedAvailable",
      to="/completed/",
      @click="close"
    )
      a(@click="close") {{ $t("certificates") }}

    a.navbar__item(:href="termsAndConditionsLink", target="_blank") {{ $t("tos") }}
    a.navbar__item(:href="privacyPolicyLink", target="_blank") {{ $t("privacyPolicy") }}
  .profile-deletion(v-if="userDeletionMode !== 'none'")
    h3 {{ $t("deleteAccount") }}
    el-popconfirm(
      :title="userDeletionConfirmation",
      :confirm-button-text="$t('delete')",
      :cancel-button-text="$t('cancel')",
      :confirm-button-type="'danger'",
      :cancel-button-type="'primary'",
      @confirm="requestUserDeletion",
      width="300"
    )
      template(#reference)
        el-button#request-user-deletion(
          v-loading="userDeletionLoading",
          type="danger",
          :disabled="userDeletionLoading || deletionRequested"
        ) {{ userDeletionActionLabel }}
    p(v-if="deletionRequested") {{ $t("userDeletionRequested") }}
</template>

<script>
import configApi from "@/services/config";
import RolesScopesMixin from "../admin/admin-action/mixins/RolesScopesMixin";
import roles from "@/utils/roles";
import { Accounts } from "@inctec/elearning-ui-client";
import { ElNotification } from "element-plus";

export default {
  name: "MiscellaneousUserActions",
  mixins: [RolesScopesMixin],
  data() {
    return {
      configApi,
      user: null,
      userDeletionLoading: false,
    };
  },
  computed: {
    privacyPolicyLink() {
      return this.$getSetting("privacyPolicyLink").replace(
        "$langcode",
        this.$i18n.locale,
      );
    },
    termsAndConditionsLink() {
      return this.$getSetting("termsAndConditionsLink").replace(
        "$langcode",
        this.$i18n.locale,
      );
    },
    isCovidAvailable() {
      return this.$getSetting("showCovidView");
    },
    isTestcenterAvailable() {
      return this.$getSetting("showTestCenterView");
    },
    isCompletedAvailable() {
      return this.hasScope("users_get_courses_completed");
    },
    userDeletionMode() {
      const userAccountIds = new Set(
        this.user?.accounts
          .map((account) => account.id)
          .filter((account) => typeof account === "number") ?? [],
      );
      const modes = (this.$store.getters.getAccounts || [])
        .filter((account) => userAccountIds.has(account.id))
        .map((account) => account.settings?.userDeletionMode || "none");
      if (modes.includes("delete")) return "delete";
      if (modes.includes("request")) return "request";
      return "none";
    },
    deletionRequested() {
      return this.user?.deletionRequestedAt != null;
    },
    userDeletionActionLabel() {
      return this.userDeletionMode === "delete"
        ? this.$t("deleteAccount")
        : this.$t("requestUserDeletion");
    },
    userDeletionConfirmation() {
      return this.userDeletionMode === "delete"
        ? this.$t("confirmUserDeletion")
        : this.$t("confirmUserDeletionRequest");
    },
  },
  mounted() {
    this.$store.dispatch("initAccounts", { keepCache: true });
    this.loadUser();
  },
  methods: {
    close() {
      console.log("close");
      this.$emit("close");
    },
    saveGDPRtxt() {
      this.$store.dispatch("getGDPR", true);
    },
    async loadUser() {
      try {
        const response = await Accounts.searchUsers({
          body: {
            page: 1,
            pageSize: 1,
            users: [this.$store.getters.getUserData.id],
          },
        });
        this.user = response.data?.result?.[0] || null;
      } catch {
        this.user = null;
      }
    },
    async requestUserDeletion() {
      this.userDeletionLoading = true;
      try {
        await Accounts.requestUserDeletion({
          path: { userId: this.$store.getters.getUserData.id },
          body: {},
        });
        if (this.userDeletionMode === "delete") {
          ElNotification.success({
            message: this.$t("userDeletionSuccessful"),
          });
          this.close();
          await this.$nextTick();
          await this.$store.dispatch("logout", { hideNext: true });
          return;
        }
        if (this.user) {
          this.user = {
            ...this.user,
            deletionRequestedAt: new Date().toISOString(),
          };
        }
        this.$store.commit("addNewNotification", {
          title: "success",
          text: this.$t("userDeletionRequested"),
          notificationType: "success",
        });
      } catch {
        this.$store.commit("addNewNotification", {
          title: "error",
          text: this.$t("genericError"),
          notificationType: "error",
        });
      } finally {
        this.userDeletionLoading = false;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import "../../settings.styl"
.link-wrapper > * {
  color: $hyperlink;
  margin-left: 0;
  margin-top: 2rem;
  }
</style>

<style scoped>
.profile-deletion {
  border-top: 1px solid var(--el-border-color);
  margin-top: 1.5rem;
  padding-top: 1.5rem;
}
</style>
